export const roles = {
    admin: 'admin',
    standard: 'standard',
    lowAccess: 'low_access'
};

